module.exports = __webpack_public_path__ + "img/ico-close.d632969d.svg";